import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { NotificationSettings } from "@/components/app/notification-settings";

const description =
  "Choose which internal recipients get emailed when applications, events, and signups happen.";

export const Route = createFileRoute("/_authenticated/t1dwpanel/notifications")({
  head: () => ({
    meta: [
      { title: "Email notifications | Warrior Volunteer" },
      { name: "description", content: description },
      { property: "og:title", content: "Email notifications | Warrior Volunteer" },
      { property: "og:description", content: description },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: NotificationsPage,
});

function NotificationsPage() {
  return (
    <AppShell title="Email notifications" eyebrow="Admin">
      <NotificationSettings />
    </AppShell>
  );
}
